import _defineProperty from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Image from "../CustomImage";
import React from "react";
import ReactIdSwiper from "react-id-swiper";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SwiperGallery = function SwiperGallery(props) {
  var data = props.data;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      lightBoxOpen = _React$useState2[0],
      setLightBoxOpen = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      activeImage = _React$useState4[0],
      setActiveImage = _React$useState4[1];

  var _onClick = function onClick(index) {
    setActiveImage(index);
    setLightBoxOpen(!lightBoxOpen);
  };

  var edgeSlidesClick = React.useCallback(function (index) {
    _onClick(index);
  }, []);
  React.useEffect(function () {
    var firstSlide = document.querySelector(".swiper-slide-prev");
    var lastSlide = document.querySelector(".swiper-slide-duplicate-next");

    if (firstSlide) {
      firstSlide.addEventListener("click", function () {
        return edgeSlidesClick(data.length - 1);
      });
    }

    if (firstSlide && firstSlide.previousSibling) {
      firstSlide.previousSibling.addEventListener("click", function () {
        return edgeSlidesClick(data.length - 2);
      });
    }

    if (lastSlide) {
      lastSlide.addEventListener("click", function () {
        return edgeSlidesClick(1);
      });
    }

    if (lastSlide && lastSlide.previousSibling) {
      lastSlide.previousSibling.addEventListener("click", function () {
        return edgeSlidesClick(0);
      });
    }

    return function () {
      if (firstSlide) {
        firstSlide.removeEventListener("click", function () {
          return edgeSlidesClick();
        });
      }

      if (firstSlide && firstSlide.previousSibling) {
        firstSlide.previousSibling.removeEventListener("click", function () {
          return edgeSlidesClick();
        });
      }

      if (lastSlide) {
        lastSlide.addEventListener("click", function () {
          return edgeSlidesClick();
        });
      }

      if (lastSlide && lastSlide.previousSibling) {
        lastSlide.previousSibling.addEventListener("click", function () {
          return edgeSlidesClick(0);
        });
      }
    };
  }, [edgeSlidesClick]);
  var params = {
    rebuildOnUpdate: true,
    slidesPerView: 3,
    spaceBetween: 5,
    loop: true,
    roundLengths: true,
    centeredSlides: true,
    breakpoints: {
      991: {
        slidesPerView: 3
      },
      565: {
        slidesPerView: 2
      },
      300: {
        slidesPerView: 1
      }
    },
    pagination: {
      el: ".swiper-pagination.swiper-pagination-white",
      type: 'fraction'
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  };
  var customStyles = {
    overlay: {
      zIndex: "1000"
    },
    bodyOpen: {
      position: "fixed"
    }
  };
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(ReactIdSwiper, _objectSpread(_objectSpread({}, params), {}, {
      children: data.map(function (item, index) {
        return /*#__PURE__*/_jsx("div", {
          className: "img-gallery",
          children: /*#__PURE__*/_jsx(Image, {
            src: "".concat(item.img),
            width: 1350,
            height: 900,
            layout: "responsive",
            alt: item.alt,
            loading: "eager",
            className: "img-fluid img-gallery",
            sizes: "35vw",
            onClick: function onClick() {
              return _onClick(index);
            }
          })
        }, index);
      })
    })), lightBoxOpen && /*#__PURE__*/_jsx(Lightbox, {
      mainSrc: "".concat(data[activeImage].img),
      nextSrc: "".concat(data[(activeImage + 1) % data.length].img),
      prevSrc: "".concat(data[(activeImage + data.length - 1) % data.length].img),
      onCloseRequest: function onCloseRequest() {
        return setLightBoxOpen(false);
      },
      imageCaption: data[activeImage].title,
      onMovePrevRequest: function onMovePrevRequest() {
        return setActiveImage((activeImage + data.length - 1) % data.length);
      },
      onMoveNextRequest: function onMoveNextRequest() {
        return setActiveImage((activeImage + 1) % data.length);
      },
      enableZoom: false,
      reactModalStyle: customStyles
    })]
  });
};

export default SwiperGallery;